import React, { CSSProperties } from "react";

interface IProps {
    color?: string;
    style?: CSSProperties;
    svgWidth?: string;
    svgHeight?: string;
}
const LapARTotumLogo: React.FC<IProps> = (props: IProps) => {
    const { color } = props;
    return (
        <div style={props?.style}>
            <svg
                width={props.svgWidth || "32"}
                height={props.svgHeight || "32"}
                className="images-icon"
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                viewBox="0 0 256 256"
            >
                <path
                    fill={color ? color : "#4583c4"}
                    d="M75.9 59.3c-5.4 0-9.8 4.4-9.8 9.8s4.4 9.8 9.8 9.8c5.5 0 9.8-4.3 9.8-9.8s-4.3-9.8-9.8-9.8z"
                />
                <path
                    fill={color ? color : "#4583c4"}
                    d="M216 0H40C18 0 0 18 0 40v176c0 22 18 40 40 40h95.8l-47.5-98.5-40.4 85.6H28.5l59.8-126.8L155.7 256H216c22 0 40-18 40-40V40c0-22-18-40-40-40zm-63.9 50.9h9.4v19.9c0 4.8 2.1 8.1 7.3 8.1 5.2 0 7.4-3.2 7.4-8.1V50.9h9.4v20.5c0 10.1-6.7 16.6-16.8 16.6-10.1 0-16.7-6.4-16.7-16.6V50.9zM45 60.1H33.7v27.3h-9.4V60.1h-8.9c-.5-3.2-1.4-6.2-2.5-9.1H45v9.1zM75.9 88c-10.4 0-19.3-8.4-19.3-18.9s8.9-18.9 19.3-18.9c10.5 0 19.3 8.3 19.3 18.9S86.3 88 75.9 88zm62.8-27.9h-11.3v27.3H118V60.1h-8.9c-.5-3.2-1.4-6.2-2.5-9.1h32.1v9.1zM222.4 243h-20.1l-35.2-72.2h25.3s18.9 1 17.7-18.2c0 0 .3-20.2-19.6-19.9l-42-.3-7.8-16 51.2-.1c.1.1 35.8-2 35.7 36.5 0 0 1.3 33.1-33.3 32.4l28.1 57.8zM240 87.3h-9.4V70.4l-7.4 16.9H217l-7.4-16.9v16.9h-9.4V50.9h9.4L220 73.8l10.5-22.9h9.4v36.4z"
                />
            </svg>
        </div>
    );
};

export default LapARTotumLogo;
